<template>
  <div class="change-theme">
    <sword-button-wuk
      v-for="(themeName, key) in supportedThemes"
      :key="key"
      :text="themeName"
      theme="tertiary"
      :disabled="isCurrentTheme(themeName)"
      @click.native="changeTheme(themeName)"
    >
      {{ themeName }}
    </sword-button-wuk>
  </div>
</template>

<script>
import SwordButtonWuk from '@ui-kit/components/buttons/SwordButton.vue';

export default {
  name: 'ThemeSelector',
  components: {
    SwordButtonWuk,
  },
  model: {
    prop: 'currentTheme',
    event: 'changeTheme',
  },
  props: {
    currentTheme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      // supportedThemes: ['Bloom', 'Sword', 'Big', 'Eco', 'Move', 'Become'],
      supportedThemes: ['Sword', 'Become'],
    };
  },
  methods: {
    changeTheme(themeName) {
      this.$emit('change-theme', themeName.toLowerCase());
    },
    isCurrentTheme(themeName) {
      return this.currentTheme.toLowerCase() === themeName.toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.change-theme {
  position: fixed;
  display: flex;
  gap: 1rem;
  bottom: 1rem;
  right: 1rem;
  padding: 0.5rem;
  z-index: 2000;
  background-color: $color-grey-400;
  border-radius: 1rem;
}
</style>
